const attendances = [{
    "date": "2024-02-17",
    "checkIn": "11:05:46",
    "checkOut": "18:44:57"
  }, {
    "date": "2024-08-25",
    "checkIn": "11:43:27",
    "checkOut": "19:50:07"
  }, {
    "date": "2024-04-29",
    "checkIn": "9:42:23",
    "checkOut": "17:08:46"
  }, {
    "date": "2024-08-11",
    "checkIn": "9:32:48",
    "checkOut": "19:03:10"
  }, {
    "date": "2024-10-01",
    "checkIn": "9:58:17",
    "checkOut": "19:14:18"
  }, {
    "date": "2024-01-03",
    "checkIn": "10:26:56",
    "checkOut": "19:18:01"
  }, {
    "date": "2024-10-07",
    "checkIn": "9:02:30",
    "checkOut": "21:55:14"
  }, {
    "date": "2024-03-31",
    "checkIn": "10:44:49",
    "checkOut": "21:18:27"
  }, {
    "date": "2024-09-26",
    "checkIn": "9:46:04",
    "checkOut": "18:40:33"
  }, {
    "date": "2024-06-15",
    "checkIn": "8:22:50",
    "checkOut": "20:20:28"
  }, {
    "date": "2024-07-06",
    "checkIn": "11:01:00",
    "checkOut": "16:19:24"
  }, {
    "date": "2024-10-04",
    "checkIn": "11:08:06",
    "checkOut": "20:24:31"
  }, {
    "date": "2024-01-03",
    "checkIn": "10:00:57",
    "checkOut": "21:47:17"
  }, {
    "date": "2024-03-28",
    "checkIn": "11:24:05",
    "checkOut": "21:37:41"
  }, {
    "date": "2024-02-26",
    "checkIn": "8:42:46",
    "checkOut": "19:05:45"
  }, {
    "date": "2024-08-17",
    "checkIn": "10:09:28",
    "checkOut": "17:10:00"
  }, {
    "date": "2024-04-09",
    "checkIn": "11:19:35",
    "checkOut": "19:38:16"
  }, {
    "date": "2024-09-14",
    "checkIn": "9:45:43",
    "checkOut": "22:30:19"
  }, {
    "date": "2024-01-01",
    "checkIn": "10:27:01",
    "checkOut": "18:54:59"
  }, {
    "date": "2024-06-21",
    "checkIn": "9:05:20",
    "checkOut": "17:07:34"
  }, {
    "date": "2024-05-30",
    "checkIn": "9:58:24",
    "checkOut": "16:36:09"
  }, {
    "date": "2024-01-02",
    "checkIn": "10:59:13",
    "checkOut": "20:11:51"
  }, {
    "date": "2024-07-07",
    "checkIn": "10:30:43",
    "checkOut": "16:24:34"
  }, {
    "date": "2024-04-22",
    "checkIn": "9:12:31",
    "checkOut": "20:14:41"
  }, {
    "date": "2024-01-02",
    "checkIn": "9:08:21",
    "checkOut": "18:52:44"
  }, {
    "date": "2024-03-08",
    "checkIn": "8:50:40",
    "checkOut": "16:08:23"
  }, {
    "date": "2024-02-13",
    "checkIn": "10:07:15",
    "checkOut": "17:03:43"
  }, {
    "date": "2024-07-22",
    "checkIn": "11:06:57",
    "checkOut": "21:17:13"
  }, {
    "date": "2024-02-08",
    "checkIn": "10:02:14",
    "checkOut": "16:33:05"
  }, {
    "date": "2024-06-18",
    "checkIn": "9:06:36",
    "checkOut": "21:36:49"
  }, {
    "date": "2024-08-29",
    "checkIn": "9:34:11",
    "checkOut": "22:27:37"
  }, {
    "date": "2024-09-20",
    "checkIn": "11:45:07",
    "checkOut": "18:42:52"
  }, {
    "date": "2024-01-01",
    "checkIn": "9:08:56",
    "checkOut": "20:44:07"
  }, {
    "date": "2024-05-01",
    "checkIn": "8:09:06",
    "checkOut": "22:03:58"
  }, {
    "date": "2024-04-19",
    "checkIn": "11:13:04",
    "checkOut": "16:48:10"
  }, {
    "date": "2024-01-05",
    "checkIn": "8:23:05",
    "checkOut": "21:23:06"
  }, {
    "date": "2024-03-20",
    "checkIn": "9:49:43",
    "checkOut": "16:01:29"
  }, {
    "date": "2024-07-07",
    "checkIn": "8:35:46",
    "checkOut": "16:23:05"
  }, {
    "date": "2024-05-06",
    "checkIn": "9:55:09",
    "checkOut": "16:56:06"
  }, {
    "date": "2024-10-04",
    "checkIn": "9:50:00",
    "checkOut": "21:30:24"
  }, {
    "date": "2024-04-19",
    "checkIn": "10:41:27",
    "checkOut": "21:26:48"
  }, {
    "date": "2024-02-18",
    "checkIn": "8:33:33",
    "checkOut": "22:07:20"
  }, {
    "date": "2024-04-27",
    "checkIn": "10:34:41",
    "checkOut": "19:44:32"
  }, {
    "date": "2024-06-20",
    "checkIn": "11:46:43",
    "checkOut": "18:21:02"
  }, {
    "date": "2024-04-19",
    "checkIn": "8:33:12",
    "checkOut": "20:17:07"
  }, {
    "date": "2024-08-21",
    "checkIn": "11:40:49",
    "checkOut": "21:37:40"
  }, {
    "date": "2024-03-29",
    "checkIn": "9:34:47",
    "checkOut": "17:25:34"
  }, {
    "date": "2024-02-01",
    "checkIn": "10:07:19",
    "checkOut": "20:48:56"
  }, {
    "date": "2024-06-21",
    "checkIn": "11:14:35",
    "checkOut": "20:09:57"
  }, {
    "date": "2024-09-02",
    "checkIn": "10:51:00",
    "checkOut": "20:58:37"
  }, {
    "date": "2024-06-24",
    "checkIn": "9:30:39",
    "checkOut": "22:12:24"
  }, {
    "date": "2024-09-16",
    "checkIn": "9:40:44",
    "checkOut": "18:30:50"
  }, {
    "date": "2024-06-19",
    "checkIn": "9:39:55",
    "checkOut": "22:34:06"
  }, {
    "date": "2024-06-11",
    "checkIn": "10:32:56",
    "checkOut": "17:01:55"
  }, {
    "date": "2024-07-26",
    "checkIn": "8:48:08",
    "checkOut": "18:03:55"
  }, {
    "date": "2024-01-13",
    "checkIn": "11:02:26",
    "checkOut": "18:44:26"
  }, {
    "date": "2024-01-02",
    "checkIn": "10:35:57",
    "checkOut": "16:04:00"
  }, {
    "date": "2024-05-22",
    "checkIn": "9:25:29",
    "checkOut": "18:14:41"
  }, {
    "date": "2024-06-29",
    "checkIn": "9:42:57",
    "checkOut": "16:30:31"
  }, {
    "date": "2024-06-16",
    "checkIn": "9:35:03",
    "checkOut": "16:28:39"
  }]

  
  export default attendances